import { Subscription } from 'rxjs';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { ApiService } from 'src/app/providers/api.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ITableColumnHeader } from 'src/app/models/table-column-header';
import { AddTargetNotificationComponent } from 'src/app/shared/components/add-target-notification/add-target-notification.component';
import { NavigationService } from '../../../providers/navigation.service';

@Component({
  selector: 'sm-target-notification',
  templateUrl: './target-notification.component.html',
  styleUrls: ['./target-notification.component.scss'],
})
export class TargetNotificationComponent implements OnInit, OnDestroy {
  tableDisplayColumns: ITableColumnHeader[] = [];
  notificationList: any[] = [];
  public isLoading: boolean = false;
  private _apiSubscription: Subscription = new Subscription();

  constructor(private _modelRef: MatDialog, private _apiService: ApiService,   private _navService: NavigationService,) {
    this._navService.hideSidebarAndNav = false;
    this.tableDisplayColumns = [
      {
        columnName: 'date',
        columnProperty: 'creationDate',
      },
      {
        columnName: 'title',
        columnProperty: 'topicTitle',
      },
      {
        columnName: 'message',
        columnProperty: 'topicMessage',
      },
      {
        columnName: 'topic',
        columnProperty: 'topic',
      },
    ];
  }

  ngOnDestroy() {
    this._apiSubscription.unsubscribe();
  }

  ngOnInit(): void {
    this.isLoading = true;
    this._apiService.getTargetedNotificationsList();
    this._modelRef.afterAllClosed.subscribe(() => {
      this.isLoading = true;
      this._apiService.getTargetedNotificationsList();
    });
    this._apiSubscription = this._apiService.apiResult.subscribe((data) => {
      console.log('Data', data);
      if (
        data.responseType === SM_CONSTANTS.GET_TARGETED_NOTIFICATIONS_RESULT
      ) {
        if (data.result) {
          this.notificationList = data.result;
        } else {
          this.notificationList = [];
        }
      }
      this.isLoading = false;
    });
  }

  onCreateNewTargetNotification() {
    this._modelRef.open(AddTargetNotificationComponent, {
      minWidth: '400px',

      data: {
        title: 'Add target notification',
        ref: this._modelRef,
      },
    });
  }
}
